import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  makeSyncReduxWithLocalStorageObserver,
  restoreFromLocalStorage,
} from 'app/dataManagement/syncReduxStateWithLocalStorage';
import observeStore from 'app/utils/redux/observeStore';
import _ from 'lodash';
import { Store } from 'redux';

export const CONSTRUCTOR_CONFIGURATION_LOCAL_STORAGE_KEY = 'redux.constructorConfiguration';

export type ConstructorConfigurationState = {
  isDemoModeEnabled?: boolean;
  isTelemetryDemoEnabled?: boolean;
};

const constructorConfigurationSlice = createSlice({
  name: 'constructorConfiguration',
  initialState: () =>
    Object.freeze<ConstructorConfigurationState>(
      restoreFromLocalStorage(CONSTRUCTOR_CONFIGURATION_LOCAL_STORAGE_KEY, {})
    ),
  reducers: {
    setDemoModeEnabled(state: ConstructorConfigurationState, action: PayloadAction<boolean>) {
      state.isDemoModeEnabled = action.payload;
      if (action.payload) {
        state.isTelemetryDemoEnabled = false;
      }
    },
    setTelemetryDemoModeEnabled(
      state: ConstructorConfigurationState,
      action: PayloadAction<boolean>
    ) {
      state.isTelemetryDemoEnabled = action.payload;
      if (action.payload) {
        state.isDemoModeEnabled = false;
      }
    },
  },
});

type StoreWithConstructorConfigurationState = {
  constructorConfiguration: ConstructorConfigurationState;
};

export const selectConstructorConfiguration = (
  state: StoreWithConstructorConfigurationState
): ConstructorConfigurationState => state.constructorConfiguration;

export const attachConstructorConfigurationWithLocalStorageSynchronizationObserver = <
  S extends StoreWithConstructorConfigurationState
>(
  store: Store<S>
) => {
  observeStore(
    store,
    selectConstructorConfiguration,
    makeSyncReduxWithLocalStorageObserver(CONSTRUCTOR_CONFIGURATION_LOCAL_STORAGE_KEY)
  );
};

const constructorConfigurationReducer = constructorConfigurationSlice.reducer;

export const { setDemoModeEnabled, setTelemetryDemoModeEnabled } =
  constructorConfigurationSlice.actions;

export default constructorConfigurationReducer;
